import { render, staticRenderFns } from "./ButtonSwitch.vue?vue&type=template&id=bd62d270&scoped=true&"
import script from "./ButtonSwitch.vue?vue&type=script&lang=ts&"
export * from "./ButtonSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonSwitch.vue?vue&type=style&index=0&id=bd62d270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd62d270",
  null
  
)

export default component.exports